import { gql } from '@apollo/client';

export const deletePromptMutation = gql`
  mutation deletePrompt($promptId: ID!) {
    deleteArticle(where: { id: $promptId }) {
      id
    }
  }
`;
